<h1 class="fs-1 fw-bold text-left mt-3">{{ titlePage | titlecase }}</h1>
<!--<div *ngFor="let layout of pageLayouts">
  <ng-container *ngIf="!!layout['id'] && layout['id']=='LYO_GENERAL'">
    <layout-general [layout]="layout"></layout-general>
  </ng-container>
</div>-->

<div>
</div>
